import {useContext, useEffect} from "react";
import { TopLoaderContext } from "../context/TopLoader";

const UseLandingLoader = () => {
  const {loadingRef} = useContext(TopLoaderContext);
  useEffect(() => {
    loadingRef.current.continuousStart();
    setTimeout(() => {
      loadingRef.current.complete();
    }, 300);
  }, [loadingRef]);
};

export default UseLandingLoader;